import React from 'react';
import { App as PropulsionApp } from '@ui-propulsion/react-components';
import { node } from 'prop-types';

export const PropulsionProvider = ({ children }) => {
  return <PropulsionApp>{children}</PropulsionApp>;
};

PropulsionProvider.propTypes = {
  children: node
};

